var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.7844 12.1521L19.6845 3.06235C19.8905 2.85211 20.004 2.57147 20.004 2.27222C20.004 1.97298 19.8905 1.69233 19.6845 1.4821L19.0292 0.812702C18.6022 0.377121 17.9082 0.377121 17.4819 0.812702L10.0081 8.44559L2.52608 0.804233C2.32006 0.593998 2.04543 0.477921 1.75259 0.477921C1.45942 0.477921 1.18478 0.593998 0.978608 0.804233L0.323491 1.47363C0.117476 1.68403 0.00398198 1.96451 0.00398198 2.26376C0.00398198 2.563 0.117476 2.84364 0.323491 3.05388L9.23171 12.1521C9.43838 12.3628 9.71431 12.4786 10.0076 12.4779C10.3021 12.4786 10.5779 12.3628 10.7844 12.1521Z","fill":"#F0D217"}));
}

ChevronDown.defaultProps = {"width":"21","height":"13","viewBox":"0 0 21 13","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
